export default {
    name: "storeApply",
    data:function () {
        return{
            info:{
              IDCardPhotoPositive: "",
              IDCardPhotoReverse: "",
              RegistrantPhoto: "",
              StorePhoto: ""
            },
            addressList:[],
            showEv:false
        }
    },
    methods:{
        back: function() {
          dsBridge.call("closeWindow", {});
        },
        confirmed: function() {
          this.$router.push({name:'qdList'});
          this.showEv = false;
        },
        submit:function () {
            var info=this.info;
            if(!info.StoreName ){
                this.$toast("请输入公司名称");
                return
            }
            if(!info.ContactPhone ){
                this.$toast("请输入联系电话");
                return
            }
            if(!info.AreaId ){
                this.$toast("请选择区域");
                return
            }
            if(!info.Area){
                this.$toast("请输入街道");
                return
            }
            if(!info.Address){
                this.$toast("请输入具体地址");
                return
            }
            if(!info.ContactsName ){
                this.$toast("请输入联系人");
                return
            }
            if(!info.Sex ){
                this.$toast("请选择性别");
                return
            }
            info.CityId =this.$getCity();
            var _this=this;
            this.$post("/customerservicemanager/storeapply",info,function (res) {
                if(res.Success){
                    window.sessionStorage.setItem("session", res.Result.Session);
                    this.showEv = true;
                }else{
                    _this.$toast("门店提交失败，"+res.Message);
                }
            })
        },
        getArea:function () {
            var _this=this;
            this.$get("/query/listarea",{
                cityid:this.$getCity()
            },function (res) {
                _this.addressList=res;
            })
        },
        checkItem:function (options) {
            console.log(options);
            this.info.AreaId=options.Id
        },
      idPositiveUpload: function(type, saObj) {
        let self = this;
        dsBridge.call(type, {}, function (data) {
          saObj.IDCardPhotoPositive = "data:image/jpeg;base64," + data;
        });
      },
      idReverseUpload: function(type, info) {
        let self = this;
        dsBridge.call(type, {}, function (data) {
          info.IDCardPhotoReverse = "data:image/jpeg;base64," + data;
        });
      },
      registrantPhotoUpload: function(type, info) {
        let self = this;
        dsBridge.call(type, {}, function (data) {
          info.RegistrantPhoto = "data:image/jpeg;base64," + data;
        });
      },
      storePhotoUpload: function(type, info) {
        let self = this;
        dsBridge.call(type, {}, function (data) {
          info.StorePhoto = "data:image/jpeg;base64," + data;
        });
      }
    },
    mounted:function () {
        this.getArea();
    },
    //filters: {
    //  base64Img: function (value) {
    //    if (!value) {
    //      return '';
    //    } else {
    //      return "data:image/jpeg;base64," + value;
    //    }
    //  }
    //}
}



// WEBPACK FOOTER //
// ./src/ally/page/storeApply.js